import { IContextualMenuItem } from 'office-ui-fabric-react';

const exportTypes = {
  'EXCEL': {
    iconName: 'ExcelLogoInverse',
    text: 'Экспортировать таблицу в Excel',
  },
  'PDF': {
    iconName: 'PDF',
    text: 'Экспортировать таблицу в PDF',
  },
  'CSV': {
    iconName: 'TableGroup',
    text: 'Экспортировать таблицу в CSV',
  }
};




export const getExportButton = (
  disabled: boolean,
  onItemClick: (_: any, item?: IContextualMenuItem) => void,
  exportTypesRecord: Record<string, { iconName: string, text: string }> = exportTypes,
) => ({
  key: 'export',
    text: 'Экспортировать результат',
    iconProps: { iconName: 'share' },
  subMenuProps: {
    items: Object.entries(exportTypesRecord).map(([exportName, exportType]) => ({
      key: exportName,
      iconProps: {
        iconName: exportType.iconName,
      },
      text: exportType.text,
      onClick: onItemClick,
    })),
  },
  disabled,
})